import React from 'react';
import Head from 'next/head';
import { truncate, removeHTMLTags } from '../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProviderServicePageHead = function ProviderServicePageHead(_ref) {
  var provider = _ref.provider,
      providerService = _ref.providerService;
  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("title", {
      children: "".concat(providerService.name, " by ").concat(provider.name)
    }), /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: truncate(removeHTMLTags(providerService.description), 200)
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:site_name",
      content: "Subkit"
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:title",
      content: "".concat(providerService.name, " by ").concat(provider.name)
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:description",
      content: truncate(removeHTMLTags(providerService.description), 200)
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:url",
      content: "http://subkit.com/".concat(provider.slug, "/").concat(providerService.slug)
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:image",
      content: "".concat(providerService.bgImageUrl ? providerService.bgImageUrl : '')
    }), /*#__PURE__*/_jsx("meta", {
      property: "twitter:card",
      content: "summary_large_image"
    }), /*#__PURE__*/_jsx("meta", {
      property: "twitter:title",
      content: "".concat(providerService.name, " by ").concat(provider.name)
    }), /*#__PURE__*/_jsx("meta", {
      property: "twitter:description",
      content: truncate(removeHTMLTags(providerService.description), 200)
    }), /*#__PURE__*/_jsx("meta", {
      property: "twitter:image:alt",
      content: truncate(removeHTMLTags(providerService.description), 200)
    }), /*#__PURE__*/_jsx("meta", {
      property: "twitter:url",
      content: "http://subkit.com/".concat(provider.slug, "/").concat(providerService.slug)
    }), /*#__PURE__*/_jsx("meta", {
      property: "twitter:image",
      content: "".concat(providerService.bgImageUrl ? providerService.bgImageUrl : '')
    })]
  });
};